

 <mat-expansion-panel expanded *ngIf="mainCategories.length>0 " >
    <mat-expansion-panel-header>
        <mat-panel-title>
            <h4>{{data.filterCategoryName}}</h4>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="overflowY">
    <div *ngFor="let category of mainCategories">
        <button mat-menu-item (click)="goToCategory(category)">
            <span>{{category.categoryName}}</span>
        </button>

         <div *ngIf="category.subcategories.length>0"  class="sub-category">

           <calsoft-sub-category-child-items [items]="category.subcategories"></calsoft-sub-category-child-items>
        </div>
    </div>
    </div>
</mat-expansion-panel>